import { render, staticRenderFns } from "./ChatSticker.vue?vue&type=template&id=03b1f5d6&scoped=true"
import script from "./ChatSticker.vue?vue&type=script&lang=js"
export * from "./ChatSticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b1f5d6",
  null
  
)

export default component.exports